import { ImageButton } from '../../components/button/image.button';
import { MaterialIcon } from '../../components/icon/icons';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { DistanceMeasureState } from '../../state/distance.measure.state';
import { CSS, Style } from '../measurement.popup/measurement.popup.style';
import { IkeUnit } from '@ikegps/core-shared';
import { Services } from '../../services';

addStyles(Style);

export interface DistanceMeasurePopupConfig {
	onClose: () => void;
	distanceMeasureState: DistanceMeasureState;
}

export const DistanceMeasurePopup = {
	view(cfg: DistanceMeasurePopupConfig): MithrilVNode {
		return m('div', { className: CSS.container }, [
			m('div', { className: CSS.header }, [
				m('div', { className: CSS.title }, Translate(T.TOPO_TOOL_DISTANCE_MEASURE)),
				m('div', { className: CSS.headerActions }, [
					ImageButton.view(MaterialIcon.CLOSE, {
						onclick: cfg.onClose,
						title: T.CLOSE,
					}),
				]),
			]),
			m('div', { className: CSS.content }, [
				cfg.distanceMeasureState.points.length >= 2
					? m('div', [
							m('div', { className: CSS.measurementRow }, [
								m('div', { className: CSS.measurementLabel }, Translate(T.DISTANCE_MEASURE_DISTANCE)),
								m(
									'div',
									{ className: CSS.measurementValue },
									IkeUnit.display(cfg.distanceMeasureState.distance, Services.UserSettings.units)
								),
							]),
							m('div', { className: CSS.measurementRow }, [
								m('div', { className: CSS.measurementLabel }, Translate(T.DISTANCE_MEASURE_BEARING)),
								m('div', { className: CSS.measurementValue }, cfg.distanceMeasureState.bearing.toFixed(1) + '°'),
							]),
						])
					: m('div', { className: CSS.emptyState }, Translate(T.DISTANCE_MEASURE_EMPTY_STATE)),
			]),
		]);
	},
};
